exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proTitle[data-v-01d4c1f2]{color:#ffffd8;font-weight:700;font-size:16px;text-align:center;background:#388e3c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01d4c1f2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/mid_term_project_budget/prject_bud_details/insertForm.vue
// module id = 1186
// module chunks = 3